<template>
    <div id="local">
        <div class="upload-div">
            <el-form :model="localForm" label-width="100">
                <el-upload class="upload-img" action="#" list-type="picture-card" accept=".jpg,.png" :file-list="localForm.fileList" multiple :http-request="uploadLocalImg">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                        <span class="el-upload-list__item-actions">
                            <span
                                    v-if="!disabled"
                                    class="el-upload-list__item-delete"
                                    @click="handleRemove(file)"
                            >
                              <i class="el-icon-delete"></i>
                            </span>
                          </span>
                    </div>
                </el-upload>
                <el-form-item label="图片大小">
                    <span style="font-size: 14px">宽</span>
                    <el-input style="width:100px" size="small" v-model="localForm.width"></el-input>
                    <span class="size-13" style="color: #b9b6b6">根据已设置的图片宽度，等比例缩放高度。</span>
                </el-form-item>
                <el-form-item label="文字环绕">
                    <el-radio-group v-model="localForm.aroundType">
                        <el-radio label="left">上下</el-radio>
                        <el-radio label="center"><svg-icon icon-class="around"/>围绕</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="对齐方式">
                    <el-radio-group v-model="localForm.alignType">
                        <el-radio label="left"><svg-icon icon-class="align-left"/> 左对齐</el-radio>
                        <el-radio label="center"><svg-icon icon-class="align-center"/> 居中对齐</el-radio>
                        <el-radio label="right"><svg-icon icon-class="align-right"/> 右对齐</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import '../assets/css/uploadImg.css'
    import {uploadImg} from '@/api/product/lazada'
    export default {
        name: "uploadImg",
        data() {
            return {
                disabled: false,
                localForm: {
                    fileList:[],
                    width: null,
                    aroundType: null,//文字环绕方式
                    alignType: 'left',//对齐方式
                }
            }
        },
        methods: {
            uploadLocalImg(data) {
                let formData = new FormData();
                formData.append("imageFile", data.file);
                uploadImg(formData).then(res => {
                    if (res.code == 200) {
                        this.msgSuccess("图片上传成功");
                        console.log(res.data)
                    }else{
                        this.$message.error("图片上传异常！")
                    }
                }).catch(err => {});
            },
            handleRemove(file) {
                console.log(this.localForm.fileList);
                console.log(file);
            },
        }
    }
</script>
